import Reveal from '../../../shared/Reveal/Reveal';
import { useVpsHostingDedicatedContent } from '../../../../hooks/useVpsHostingDedicatedContent';
import dedicatedImage from '../../../../assets/images/vpshosting/dedicated/main.png';
import './Dedicated.css';

const Dedicated = () => {
  const { content, isLoading } = useVpsHostingDedicatedContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, paragraphs, image } = content;

  return (
    <section className="vps-hosting-dedicated">
      <div className="vps-hosting-dedicated__inner">
        <Reveal className="vps-hosting-dedicated__media">
          <img
            className="vps-hosting-dedicated__image"
            src={image || dedicatedImage}
            alt=""
            aria-hidden="true"
          />
        </Reveal>

        <Reveal className="vps-hosting-dedicated__copy" delay={80}>
          <h2 className="vps-hosting-dedicated__title">{title}</h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="vps-hosting-dedicated__text">
              {paragraph}
            </p>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default Dedicated;
